import Splide from '/src/lib/splide.min.js';



const homePageEvents = (() => {

    let listeners = [];
    let splides = [];

    // Centralized configuration for each Splide instance
    const splideConfigs = [
        {
            selector: '#image-carousel2',
            options: {
                perPage: 4,
                gap: 20,
                pagination: false,
                arrows: false,
                autoWidth: true,
                wheel: false,
                waitForTransition: true,
                focus: 0,
                padding: { left: '18px', right: '0rem' },
                breakpoints: {
                    940: {
                        padding: { left: '0rem', right: '0rem' },
                    },
                },
            },
        },
        {
            selector: '#image-carousel-coverletter',
            options: {
                perPage: 4,
                gap: 20,
                pagination: false,
                arrows: false,
                autoWidth: true,
                wheel: false,
                waitForTransition: true,
                focus: 0,
                padding: { left: '18px', right: '0rem' },
                breakpoints: {
                    940: {
                        padding: { left: '0rem', right: '0rem' },
                    },
                },
            },
        },
        {
            selector: '#image-carousel-custom-criteria',
            options: {
                perPage: 4,
                gap: 20,
                pagination: false,
                arrows: false,
                autoWidth: true,
                wheel: false,
                waitForTransition: true,
                focus: 0,
                padding: { left: '18px', right: '0rem' },
                breakpoints: {
                    940: {
                        padding: { left: '0rem', right: '0rem' },
                    },
                },
            },
        },
        {
            selector: '#image-carousel-ready-made-templates',
            options: {
                perPage: 4,
                gap: 20,
                pagination: false,
                arrows: false,
                autoWidth: true,
                wheel: false,
                waitForTransition: true,
                focus: 0,
                padding: { left: '18px', right: '0rem' },
                breakpoints: {
                    940: {
                        padding: { left: '0rem', right: '0rem' },
                    },
                },
            },
        },
        {
            selector: '#image-carousel-ready-made-templates2',
            options: {
                perPage: 4,
                gap: 20,
                pagination: false,
                arrows: false,
                autoWidth: true,
                wheel: false,
                waitForTransition: true,
                focus: 0,
                padding: { left: '18px', right: '0rem' },
                breakpoints: {
                    940: {
                        padding: { left: '0rem', right: '0rem' },
                    },
                },
            },
        },
        {
            selector: '#image-carousel-resumes',
            options: {
                type: 'loop', // Enable infinite scrolling
                perPage: 1,   // Show only one full slide at a time
                focus: 'center', // Center the active slide
                autoWidth: true, // Allow slides to maintain their original width
                arrows: false,   // Hide arrows if you don't want them
                gap: '2rem',     // Add space between slides
                padding: { left: '0rem', right: '7.5rem' },
                breakpoints: {
                    640: {
                        gap: '1rem', // Adjust gap for smaller screens
                        padding: { left: '0rem', right: '4rem' },
                    },
                },
            },
        },
    ];

    const supportedLocales = [
        'en-US', 'de-DE', 'en-GB', 'fr-FR', 'es-419', 'ja-JP', 'it-IT', 'pt-BR', 'zh-CN'
      ];


      // Define per-language layout values for the chatbox button depending on the language
      const layoutOverrides = {
        'de-DE': { maxWidth: '200px', left: '290px' },
        'en-GB': { maxWidth: '140px', left: '230px' },
        'en-US': { maxWidth: '140px', left: '230px' },
        'fr-FR': { maxWidth: '205px', left: '295px' },
        'es-419': { maxWidth: '210px', left: '300px' },
        'it-IT': { maxWidth: '150px', left: '245px' },
        'pt-BR': { maxWidth: '200px', left: '295px' },
        'ja-JP': { maxWidth: '160px', left: '253px' },
        'zh-CN': { maxWidth: '95px', left: '185px' }
      };



    async function homePageEventsInit() {

        listeners =[];
        splides = [];
        const minLatinWords = 10;
        const minEastAsianChars = 20;
        const maxWords = 2000;
        const maxChars = 15000;
        var chatgptbox = document.getElementById('chatgptbox');
        const chatgptboxSubmit = document.getElementById("generate-resume-button");
        const submitButton = document.querySelector('.chatgptbox-submit');
        const attachFileButton =  document.querySelector('.chatgptbox-icon-left');
        const message = document.getElementById("chatbox-message");
        const pageKey = `chatgptbox_value_${window.location.pathname}`;
        const attachDefaultIcon = document.getElementById("icon-attach-default");
        const clipWithBadgeIcon = document.getElementById("icon-clip-with-badge");
        const linkedInDefaultIcon = document.getElementById("icon-linkedin-default");
        const linkedInithBadgeIcon = document.getElementById("icon-linkedin-with-badge");


        function addListener(element, event, handler) {
            if (element) {
                const options = { passive: ['wheel', 'touchstart', 'touchmove'].includes(event) }; // Add passive: true only for scroll-blocking events
                element.addEventListener(event, handler, options);
                listeners.push({ element, event, handler });
            }
        }



        if (chatgptbox) {
            // Load the saved value if it exists

            // Unified handler for both typing and pasting events
            const handleInput = () => {
                const text = chatgptbox.value;
                const isValid = isValidInput(text);
                const coverletter = chatgptboxSubmit?.getAttribute("data-action") === "generate-coverletter";


                chatgptbox.style.height = '250px'; // Reset height
                chatgptbox.style.height = `${chatgptbox.scrollHeight}px`; // Set height to content

                if (chatgptbox.scrollHeight > 300) {
                    chatgptbox.classList.add('scrollable');
                    chatgptbox.style.height = '300px';
                } else {
                    chatgptbox.classList.remove('scrollable');
                }

                if (text.trim().length === 0) {
                    message.style.lineHeight = '10px';
                    message.style.visibility = "hidden";
                    submitButton.disabled = true;
                    submitButton.classList.remove('active');
                } else {
                    const url = containsValidUrl(text);
                    if (window.innerWidth <= 720)
                        message.style.lineHeight = '20px';
                    else
                        message.style.lineHeight = '30px';

                    if (url) {
                        if (containsExecutable(url)){
                            updateMessageExecutableUrl();
                            submitButton.disabled = true;
                            submitButton.classList.remove('active');
                            return;
                        }
                        updateMessage(text, coverletter);
                        submitButton.disabled = false;
                        message.className = "chatbox-message chatbox-success";
                        message.style.visibility = "visible";
                        submitButton.classList.add('active');
                    } else if (isValid) {
                        updateMessage(text, coverletter);
                        message.style.visibility = "visible";
                        submitButton.disabled = false;
                        submitButton.classList.add('active');
                    } else {
                        updateMessage(text, coverletter);
                        submitButton.disabled = true;
                        submitButton.classList.remove('active');
                    }
                }
            };

            const savedValue = getLocalStorageItem(pageKey);
            if (savedValue) {
                chatgptbox.value = savedValue; // Populate the textbox with the saved value
                setCustomTimeout(handleInput, 10);
            }

            setCustomTimeoutIndexHtml(() => {
                const useThisFileFlag = getLocalStorageItem("useThisFile") === "true";
                if (useThisFileFlag) {
                    attachDefaultIcon && (attachDefaultIcon.style.display = "none");
                    clipWithBadgeIcon && (clipWithBadgeIcon.style.display = "inline");
                } else {
                    attachDefaultIcon && (attachDefaultIcon.style.display = "inline");
                    clipWithBadgeIcon && (clipWithBadgeIcon.style.display = "none");
                }

                const linkedInUseThisFlag = getLocalStorageItem("linkedInUseThis") === "true";
                if (linkedInUseThisFlag) {
                    linkedInDefaultIcon && (linkedInDefaultIcon.style.display = "none");
                    linkedInithBadgeIcon && (linkedInithBadgeIcon.style.display = "inline");
                } else {
                    linkedInDefaultIcon && (linkedInDefaultIcon.style.display = "inline");
                    linkedInithBadgeIcon && (linkedInithBadgeIcon.style.display = "none");
                }
            }, 200);


            // Add listeners and track them
            addListener(submitButton, 'mousedown', () => submitButton.classList.add('pressed'));
            addListener(submitButton, 'mouseup', () => submitButton.classList.remove('pressed'));
            addListener(submitButton, 'mouseleave', () => submitButton.classList.remove('pressed'));
            addListener(submitButton, 'touchstart', () => submitButton.classList.add('pressed'));
            addListener(submitButton, 'touchend', () => submitButton.classList.remove('pressed'));

            addListener(attachFileButton, 'mousedown', () => attachFileButton.classList.add('pressed'));
            addListener(attachFileButton, 'mouseup', () => attachFileButton.classList.remove('pressed'));
            addListener(attachFileButton, 'mouseleave', () => attachFileButton.classList.remove('pressed'));
            addListener(attachFileButton, 'touchstart', () => attachFileButton.classList.add('pressed'));
            addListener(attachFileButton, 'touchend', () => attachFileButton.classList.remove('pressed'));

            addListener(chatgptbox, 'input', handleInput);
            addListener(chatgptbox, 'paste', () => setCustomTimeout(handleInput, 10));
            addListener(chatgptbox, 'focusout', scrollToTopWhenWindowScrolls);

            const labelTextAttach = document.querySelector('.chatgptbox-icon-left .label-text-attach');
            const secondButton = document.querySelector('.chatgptbox-icon-second-left');
            //console.log ('setting labelTextAttach width');

            const lang = getLanguage();
            const layout = layoutOverrides[lang] || layoutOverrides['en-US'];

            if (labelTextAttach) {
                labelTextAttach.style.maxWidth = layout.maxWidth;
               // console.log ('setting labelTextAttach width to:', layout.maxWidth );
            }

            if (secondButton) {
                secondButton.style.left = layout.left;
            }
        }

        function containsExecutable(url) {
            const executablePattern = /\.(exe|msi|bat|cmd|com|scr|pif|js|vbs|dmg|jar|sh|wsf)(\?|#|$)/i;
            return executablePattern.test(url);
          }



        function containsValidUrl(text) {
            const urlPattern = /https?:\/\/[\w.-]+\.[a-z]{2,6}([\/\w.-]*)*\/?/i;
            const words = text.split(/\s+/);

            // List of paths to ignore (only if they don't have query parameters)
            const ignoredPaths = [
                "/jobs",
                "/careers",
                "/employment",
                "/join-us",
                "/work-with-us",
                "/opportunities",
                "/vacancies",
                "/recruitment"
            ];

            for (const word of words) {
                try {
                    // Create a URL object to handle parsing
                    const url = new URL(word);

                    // Normalize the hostname to ASCII using Punycode
                    const normalizedHostname = punycode.toASCII(url.hostname);
                    url.hostname = normalizedHostname;

                    // Get the full URL path including trailing slashes if any
                    let fullPath = url.pathname;
                    let hasQueryParams = url.search.length > 0; // Checks if query parameters exist

                    // Ignore only if the URL ends with an ignored path **without query parameters**
                    if (ignoredPaths.some(ignoredPath => fullPath.endsWith(ignoredPath)) && !hasQueryParams) {
                        continue; // Skip this URL
                    }

                    // Allow URLs with either a valid path OR query parameters
                    if (urlPattern.test(url.href) && (fullPath !== '/' || hasQueryParams)) {
                        return word;  // Return the original input form
                    }
                } catch (e) {
                    // Ignore invalid URLs and continue
                }
            }
            return null;
        }




        function isValidInput(text) {
            const trimmedText = text.trim();
            const charCount = trimmedText.length;

            const wordCount = trimmedText.split(/\s+/).filter(Boolean).length;

            if (wordCount > maxWords || charCount > maxChars) {
                return false;
            }

            // Check if input contains a valid URL
            const url = containsValidUrl(trimmedText);
            if (url) {
                return true;
            }


            const isNotRepeatingPattern = !/^([a-zA-Z0-9\u4e00-\u9fa5\u3040-\u30FF])\1{3,}$|^(\w+)(\s+\1)+$/u.test(trimmedText);
            const hasValidSentenceStructure = /\s/.test(trimmedText) || /[.,;?!¡¿。！？]+/.test(trimmedText) || /[\u3000-\u303F\u4E00-\u9FFF\u3040-\u30FF]/.test(trimmedText);
            const varietyThreshold = new Set(trimmedText.replace(/\s/g, '')).size > 3;
            const isEastAsian = /[\u4E00-\u9FFF\u3040-\u30FF]/u.test(trimmedText);
            const meetsLengthRequirement = isEastAsian
                ? trimmedText.length >= minEastAsianChars
                : trimmedText.split(/\s+/).filter(Boolean).length >= minLatinWords;

            return (
                trimmedText.length > 0 &&
                isNotRepeatingPattern &&
                hasValidSentenceStructure &&
                varietyThreshold &&
                meetsLengthRequirement
            );
        }

        function updateMessageExecutableUrl(){
            message.textContent = `${getI18n('error_executable_type')}`;
            message.className = "chatbox-message chatbox-warning";
            message.style.visibility = "visible";
        }

        // Example usage within updateMessage function
        function updateMessage(text, coverletter=false) {
            const wordCount = text.trim().split(/\s+/).filter(Boolean).length;
            const charCount = text.trim().length;
            const isEastAsian = /[\u4E00-\u9FFF\u3040-\u30FF]/u.test(text);
            const url = containsValidUrl(text);

            if (wordCount > maxWords) {
                const excessWords = wordCount - maxWords;
                message.textContent = getI18nExt('wordLimitExceeded', { excessWords, maxWords });
                message.className = "chatbox-message chatbox-warning";
                message.style.visibility = "visible";
            } else if (charCount > maxChars) {
                const excessChars = charCount - maxChars;
                message.textContent = getI18nExt('charLimitExceeded', { excessChars, maxChars });
                message.className = "chatbox-message chatbox-warning";
                message.style.visibility = "visible";
            } else if (url) {
                message.textContent = `${getI18n(coverletter ? 'websiteLinkFoundCoverLetter' : 'websiteLinkFound')} ${url}`;
                message.className = "chatbox-message chatbox-success";
                message.style.visibility = "visible";
            } else if (isEastAsian) {
                const remainingChars = minEastAsianChars - charCount;
                if (charCount >= minEastAsianChars) {
                    message.textContent = getI18n('charRequirementMet');
                    message.className = "chatbox-message chatbox-success";
                    message.style.visibility = "visible";
                } else {
                    message.textContent = `${getI18n('needMoreChars').replace('${remainingChars}', remainingChars)}`;
                    message.className = "chatbox-message chatbox-warning";
                    message.style.visibility = "visible";
                }
            } else {
                const remainingWords = minLatinWords - wordCount;
                if (wordCount >= minLatinWords) {
                    message.textContent = getI18n('wordCountMet');
                    message.className = "chatbox-message chatbox-success";
                    message.style.visibility = "visible";
                } else {
                    message.textContent = `${getI18n('wordsShort').replace('${remainingWords}', remainingWords)}`;
                    message.className = "chatbox-message chatbox-warning";
                    message.style.visibility = "visible";
                }
            }
        }





        // Function to handle scrolling to the target element
        function scrollToTarget(event) {
            console.log ('ScrollToTarget is called');
            event.preventDefault(); // Prevent the default behavior
            event.stopPropagation(); // Prevent other listeners from firing

            const targetId = this.getAttribute('data-target');
            const target = document.querySelector(targetId);
            if (target) {
                const container = document.querySelector('#content-container-wrapper');
                if (container) {
                    // Scroll the container to the target element
                    container.scrollTop = target.offsetTop - container.offsetTop;
                }
            }
        }

        // Attach event listeners to all elements with the 'scroll-trigger' class
        const scrollTriggers = document.querySelectorAll('.scroll-trigger');
        if (scrollTriggers.length > 0) {
            scrollTriggers.forEach(function (element) {
                addListener(element, 'click', scrollToTarget);
                addListener(element, 'keydown', function (e) {
                    if (e.key === 'Enter' || e.key === ' ') {
                        scrollToTarget.call(this, e);
                    }
                });
            });
        }

        const tabLinks = document.querySelectorAll('.tab-link');
        if (tabLinks.length > 0) {
            tabLinks.forEach(link => {
                // Function to handle tab activation
                function activateTab(e) {
                    e.preventDefault();

                    // Remove active classes and border from all tabs
                    tabLinks.forEach(item => {
                        item.classList.remove('text-blue-600', 'border-blue-600', 'dark:text-blue-500', 'dark:border-blue-500', 'active', 'tabsli-active');
                        const itemSvg = item.querySelector('svg');
                        if (itemSvg) {
                            itemSvg.classList.remove('text-blue-600', 'dark:text-blue-500');
                            itemSvg.classList.add('text-gray-400', 'dark:text-gray-500');
                        }
                        item.classList.add('border-transparent'); // Reset the underline to be transparent
                    });

                    // Add active classes and border to the clicked or focused tab
                    this.classList.add('text-blue-600', 'border-blue-600', 'dark:text-blue-500', 'dark:border-blue-500', 'active', 'tabsli-active');
                    const svgElement = this.querySelector('svg');
                    if (svgElement) {
                        svgElement.classList.remove('text-gray-400', 'dark:text-gray-500');
                        svgElement.classList.add('text-blue-600', 'dark:text-blue-500');
                    }
                    this.classList.remove('border-transparent'); // Ensure the underline is visible
                }

                // Event listener for click events
                addListener(link, 'click', activateTab);
                addListener(link, 'keydown', function (e) {
                    if (e.key === 'Enter' || e.key === ' ') {
                        activateTab.call(this, e);
                    }
                });
            });
        }

        // Initialize all Splide instances
        splides = splideConfigs.map(config => initSplide(config.selector, config.options));


    }


    // Generalized function to initialize Splide instances
    function initSplide(selector, options) {
        const element = document.querySelector(selector);
        if (element) {
            const splide = new Splide(element, options).mount();
            return splide; // Return instance for tracking or further use
        }
        return null;
    }

    function unload() {
        // Remove all event listeners
        if (listeners) listeners.forEach(({ element, event, handler }) => {
            element.removeEventListener(event, handler);
        });
        listeners = [];
        listeners=null;

        // Destroy Splide instances safely
        if (splides) splides.forEach(splide => {
            if (splide) {
                splide.destroy(); // Only call destroy if splide is not null
            }
        });
        splides = [];
        splides = null;

        // Reset all elements matched by the selectors in `splideConfigs`
        if (splideConfigs) splideConfigs.forEach(config => {
            const element = document.querySelector(config.selector);
            if (element) {
                // Clear content or reset styles
                element.innerHTML = ""; // Optional: Clear content
                element.style = ""; // Optional: Reset inline styles
            }
        });


        // Nullify variables
        Object.keys(window).forEach(key => {
            if (key.startsWith('chatgptbox') || key === 'splides' || key === 'listeners') {
                window[key] = null;
            }
        });
    }




    return {
        homePageEventsInit, unload
    };
});

export {
    homePageEvents
};
